import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { CustomDataTableHeader, CustomPanel, PageHeader } from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import PatrimonioOwnerModal from './PatrimonioOwnerModal'
import { connect } from 'react-redux'
import { showMessageBox } from '../../../../store/actions/system.actions'
import PatrimonioOwnerHttp from '../../../../services/api/https/patrimonio/patrimonio-owner.http'

function PatrimonioOwner({ history, dispatch }) {
  const [owners, setOwners] = useState([])
  const [globalFilter, setGlobalFilter] = useState('')
  const [selectedOwner, setSelectedOwner] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    PatrimonioOwnerHttp.fetchOwners()
      .then(savedOwners => {
        setOwners(savedOwners)
        setIsLoading(false)
      })
      .catch(error => {
        setIsLoading(false)
        dispatch(showMessageBox(null, error))
      })
  }, [])
  // Events
  const onBtnNovoClick = () => {
    setSelectedOwner({ id: null, name: '' })
  }

  const onOwnerItemClick = item => {
    setSelectedOwner({ ...item })
  }

  const onModalResponse = (action, payload) => {
    if (action === 'close') {
      setSelectedOwner(null)
    } else if (action === 'error') {
      dispatch(showMessageBox(null, payload))
    } else if (action === 'success') {
      dispatch(showMessageBox('Operação realizada com sucesso', null))
      setOwners(prevState => {
        const index = prevState.findIndex(s => s.id === payload.id)
        if (index !== -1) {
          prevState[index] = payload
        } else {
          prevState.push(payload)
        }
        return [...prevState]
      })
      setSelectedOwner(null)
    }
  }

  // render
  return (
    <>
      <PageHeader>S.15 - Patrimônio Owner</PageHeader>
      <CustomPanel onNovo={onBtnNovoClick} onVoltar={history.goBack}>
        <div className="p-grid">
          <div className="p-col-12">
            <DataTable
              value={owners}
              emptyMessage={'Não existe nenhum Owner Cadastrado'}
              globalFilter={globalFilter}
              header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
              selectionMode={'single'}
              onSelectionChange={e => onOwnerItemClick(e.value)}
              loading={isLoading}
            >
              <Column field={'id'} header={'Código'} style={tableCellCentered(80)} />
              <Column field={'name'} header={'Patrimônio Owner'} />
            </DataTable>
          </div>
        </div>
      </CustomPanel>
      <PatrimonioOwnerModal
        visible={selectedOwner !== null}
        onResponse={onModalResponse}
        selectedOwner={selectedOwner}
      />
    </>
  )
}

export default connect()(withRouter(PatrimonioOwner))
